export default __webpack_public_path__ + "static/src/companys/cmbi/assets/images/logo/logo_dark.png";